export var EsignType;
(function (EsignType) {
    EsignType[EsignType["SsnRequired"] = 0] = "SsnRequired";
    EsignType[EsignType["SsnNotRequired"] = 1] = "SsnNotRequired";
    EsignType[EsignType["SsnNotRequiredCanAdd"] = 2] = "SsnNotRequiredCanAdd";
    EsignType[EsignType["SsnNotRequiredForVendor"] = 3] = "SsnNotRequiredForVendor";
})(EsignType || (EsignType = {}));
export var CustomerRole;
(function (CustomerRole) {
    CustomerRole[CustomerRole["NotSet"] = 0] = "NotSet";
    CustomerRole[CustomerRole["Customer"] = 1] = "Customer";
    CustomerRole[CustomerRole["CoSigner"] = 2] = "CoSigner";
    CustomerRole[CustomerRole["Guarantor"] = 3] = "Guarantor";
    CustomerRole[CustomerRole["Supplier"] = 5] = "Supplier";
    CustomerRole[CustomerRole["Custom"] = 6] = "Custom";
    CustomerRole[CustomerRole["LimitCustomer"] = 7] = "LimitCustomer";
    CustomerRole[CustomerRole["Vendor"] = 8] = "Vendor";
    CustomerRole[CustomerRole["ResidualValueGuarantor"] = 9] = "ResidualValueGuarantor";
    CustomerRole[CustomerRole["Spouse"] = 10] = "Spouse";
    CustomerRole[CustomerRole["Cohabitant"] = 11] = "Cohabitant";
    CustomerRole[CustomerRole["HouseOwner"] = 12] = "HouseOwner";
})(CustomerRole || (CustomerRole = {}));
//# sourceMappingURL=commonEnums.js.map